import PaymentAccount from "./PaymentAccount";

export default PaymentAccount;
